import SearchItem from "../../../../components/SearchItem";
import request from "../../../../request";
import ImageIcon from '@mui/icons-material/Image';

export default function SelectQuickbooksEntity({ id, label, onChange, value, disabled=false, itemType, fetchUrl, flattenItems=false  }) {
   return <SearchItem
      id={id}
      value={value}
      disabled={disabled}
      fetchData={async () => {
         const res = await request.get(fetchUrl);
         
         function flatten(items, level = 0) {
            return items.flatMap(item => {
               return [{ ...item, level }, ...flatten(item.children, level + 1)];
            });
         }

         const items = res.data.accounts || res.data.products || res.data;
         return flattenItems ? flatten(items) : items;

      }}
      renderOption={
         (props, item) => <li {...props} className="p-2">
            <div style={{ padding: `0 ${item.level * 20}px` }} className="grid grid-cols-[auto,1fr] pb-2 gap-2 overflow-hidden border-b-[1px] cursor-pointer">
               <div className="flex items-center text-gray-400 text-4xl">
                  <ImageIcon fontSize="inherit" />
               </div>
               <div className="flex flex-col justify-center text-sm overflow-hidden">
                  <div className="font-bold truncate">
                     {item.name}
                  </div>
                  <div className="text-gray-500 truncate text-xs capitalize">
                     {itemType}
                  </div>
               </div>
            </div>
         </li>
      }
      transformOption={(option) => ({ ...option, label: option.name })}
      onChange={onChange}
      size="small"
      label={label}
      variant="outlined"
      dataNotFetchedMessage="Failed to fetch data."
      emptyStateMessage="No items found."
   />
}